export default __webpack_public_path__ + "c26ae8a2587c6e0f1240ac0ab8a2ff52.svg";